import React from "react";
import { observer } from "mobx-react";
import { withTranslation } from "react-i18next";
import productsListStorage from "../../storages/productsListStorage";
import layoutStorage from "../../storages/layoutStorage";
import DropDownArrow from "../../components/Dropdowns/DropDownArrow";
import DropDownIcon from "../../assets/SvgIcons/DropDownIcon";
import filtersStorage from "../../storages/filtersStorage";
import PopperItem from "../../components/PopperItem";

function CollectionControl({ t }) {
  return (
    <div className="collection-control mb-25 mb-lg-30">
      <div className="row">
        <div className="col-6 col-lg d-flex d-lg-flex align-items-center">
          <div className="d-flex d-lg-none mr-30">
            <div
              className="collection-control__button-sidebar d-flex align-items-center cursor-pointer js-popup-button"
              onClick={() => layoutStorage.openPopup("filters")}
            >
              <i className="mr-5">
                <svg
                  aria-hidden="true"
                  focusable="false"
                  role="presentation"
                  className="icon icon-theme-084"
                  viewBox="0 0 24 24"
                >
                  <path d="M19.292 1.871c.169 0 .315.063.439.186a.601.601 0 0 1 .186.439v2.5a.657.657 0 0 1-.039.225.499.499 0 0 1-.117.186l-5.469 6.074v6.641a.582.582 0 0 1-.078.293.823.823 0 0 1-.195.234l-3.75 2.5c-.052.026-.107.049-.166.068a.603.603 0 0 1-.479-.05c-.104-.052-.186-.127-.244-.225s-.088-.205-.088-.322v-9.14L3.823 5.406a.491.491 0 0 1-.117-.186.648.648 0 0 1-.039-.224v-2.5a.6.6 0 0 1 .186-.439.604.604 0 0 1 .439-.186h15zm-.625 2.89v-1.64H4.917v1.641l5.469 6.074a.507.507 0 0 1 .117.186.653.653 0 0 1 .039.225v8.203l2.5-1.66v-6.543c0-.078.013-.152.039-.225a.515.515 0 0 1 .117-.186l5.469-6.075z" />
                </svg>
              </i>
              {t("SHOW FILTER")}
            </div>
          </div>
          {layoutStorage.catalogLayout.allowShowSorts && (
            <div className="collection-control__sort-by d-block mr-20">
              <div className="select position-relative js-dropdown js-select">
                <div className="d-flex align-items-center">
                  <label
                    htmlFor="SortBy"
                    className="mb-0 mr-5 d-none d-md-block"
                  >
                    {t("Sort")}:
                  </label>
                  <select
                    name="sort_by"
                    className="p-0 pr-25 mb-0 border-0 cursor-pointer"
                    id="SortBy"
                    value={filtersStorage.orderby}
                    onChange={filtersStorage.changeOrder}
                  >
                    <option value={null}>{t("Default")}</option>
                    {/* <option value="manual">Featured</option> */}
                    {/* <option value="best-selling">Best Selling</option> */}
                    <option value="price asc">{t("Price Ascending")}</option>
                    <option value="price desc">{t("Price Descending")}</option>
                    <option value="new desc">{t("New Products")}</option>
                    <option value="sale desc">{t("Sale products")}</option>
                  </select>
                  <DropDownArrow className="position-absolute right-0 d-none d-md-block" />
                </div>
                {/* <div className="select__dropdown dropdown d-none position-lg-absolute top-lg-100 left-lg-0"> */}
                {/*  <div className="px-15 pb-30 py-lg-15"> */}
                {/*    <span data-value="manual" className="selected"> */}
                {/*      Featured */}
                {/*    </span> */}
                {/*    <span data-value="best-selling">Best Selling</span> */}
                {/*    <span data-value="price-ascending">Price Ascending</span> */}
                {/*    <span data-value="price-descending">Price Descending</span> */}
                {/*    <span data-value="created-ascending">Date Ascending</span> */}
                {/*    <span data-value="created-descending">Date Descending</span> */}
                {/*    <span data-value="title-ascending">Name Ascending</span> */}
                {/*    <span data-value="title-descending">Name Descending</span> */}
                {/*  </div> */}
                {/* </div> */}
              </div>
            </div>
          )}
        </div>
        <div className="col-lg d-none d-lg-flex justify-content-lg-center align-items-lg-center">
          <div className="collection-control__information">
            {t("products.ShowTotal", {
              startPosition: productsListStorage.startPosition + 1,
              endPosition: productsListStorage.endPosition,
              total: productsListStorage.total || 0,
            })}
          </div>
        </div>
        <div className="col-4 col-lg d-flex justify-content-lg-end align-items-center">
          <div className="collection-control__view-length d-none d-lg-block">
            <div className="select position-relative js-dropdown js-select">
              <div className="d-flex align-items-center">
                <label htmlFor="ViewLength" className="mb-0 mr-5">
                  {t("products.ItemsPerPage")}:
                </label>
                <select
                  name="view_length"
                  className="p-0 pr-25 mb-0 border-0 cursor-pointer"
                  id="ViewLength"
                  value={productsListStorage.pageSize}
                  onChange={(e) =>
                    productsListStorage.setPageSize(+e.target.value)
                  }
                >
                  <option value={24}>{24}</option>
                  <option value={24 * 2}>{24 * 2}</option>
                  <option value={23 * 3}>{24 * 3}</option>
                  <option value={24 * 4}>{24 * 4}</option>
                  <option value={24 * 5}>{24 * 5}</option>
                </select>
                <i className="position-absolute right-0">
                  <DropDownIcon />
                </i>
              </div>
              <div
                className="select__dropdown dropdown d-none position-lg-absolute top-lg-100 left-lg-0"
                data-js-dropdown
                data-js-select-dropdown
              >
                <div className="px-15 pb-30 py-lg-15">
                  <span data-value="6">6</span>
                  <span data-value="12" className="selected">
                    12
                  </span>
                  <span data-value="18">18</span>
                  <span data-value="24">24</span>
                </div>
              </div>
            </div>
          </div>
          <div
            className="collection-control__view-grid ml-auto ml-lg-15"
            data-js-tooltip
            data-tippy-content="View of item"
            data-tippy-placement="top"
            data-tippy-distance="8"
          >
            <PopperItem popperText={t("View of item")}>
              <div
                className="products-grid-buttons d-flex"
                data-js-products-grid-buttons
                data-value-xs="2"
                data-value-sm="2"
                data-value-md="4"
                data-value-lg="4"
                data-value-xl="4"
              >
                <div
                  className={`mx-8 mx-lg-1 cursor-pointer d-md-none ${
                    layoutStorage.catalogLayout.columns === 1 ? " active" : ""
                  }`}
                  // data-active-xs="true"
                  data-value="1"
                  onClick={() =>
                    layoutStorage.changeColumns("catalogLayout", 1)
                  }
                >
                  <i>
                    <svg
                      aria-hidden="true"
                      focusable="false"
                      role="presentation"
                      className="icon icon-theme-304"
                      viewBox="0 0 24 24"
                    >
                      <path d="M21.2 2.6c-.1-.1-.3-.2-.4-.2H3.3c-.2 0-.3.1-.4.2-.2.1-.2.2-.2.4v17.6c0 .1.1.2.2.3.1.1.3.2.4.2h17.5c.2 0 .3-.1.4-.2.1-.1.1-.2.2-.3V3c0-.2 0-.3-.2-.4zm-1 4.2v13.1H3.9V3.6h16.3v3.2z" />
                    </svg>
                  </i>
                </div>
                <div
                  className={`mx-8 mx-lg-1 cursor-pointer ${
                    layoutStorage.catalogLayout.columns === 2 ? "active" : ""
                  }`}
                  // data-active-sm="true"
                  data-value="2"
                  onClick={() =>
                    layoutStorage.changeColumns("catalogLayout", 2)
                  }
                >
                  <i>
                    <svg
                      aria-hidden="true"
                      focusable="false"
                      role="presentation"
                      className="icon icon-theme-185"
                      viewBox="0 0 24 24"
                    >
                      <path d="M3.306 21.142a.598.598 0 0 1-.439-.186.601.601 0 0 1-.186-.439v-17.5a.6.6 0 0 1 .186-.439.604.604 0 0 1 .439-.186h17.5c.169 0 .315.063.439.186a.601.601 0 0 1 .186.439v17.5a.6.6 0 0 1-.186.439.601.601 0 0 1-.439.186h-17.5zm.625-17.5v7.5h7.5v-7.5h-7.5zm0 16.25h7.5v-7.5h-7.5v7.5zm16.25-16.25h-7.5v7.5h7.5v-7.5zm0 16.25v-7.5h-7.5v7.5h7.5z" />
                    </svg>
                  </i>
                </div>
                <div
                  className={`mx-8 mx-lg-1 cursor-pointer d-none d-sm-block${
                    layoutStorage.catalogLayout.columns === 3 ? " active" : ""
                  }`}
                  // data-active-md="true"
                  // data-active-sm="true"
                  data-value="3"
                  onClick={() =>
                    layoutStorage.changeColumns("catalogLayout", 3)
                  }
                >
                  <i>
                    <svg
                      aria-hidden="true"
                      focusable="false"
                      role="presentation"
                      className="icon icon-theme-186"
                      viewBox="0 0 24 24"
                    >
                      <path d="M2.828 2.567a.608.608 0 0 1 .449-.175h16.875c.183 0 .332.059.449.176s.176.268.176.449v16.875c0 .183-.059.332-.176.449s-.267.176-.449.176H3.277c-.183 0-.332-.059-.449-.176s-.176-.267-.176-.449V3.017c0-.182.059-.332.176-.45zm1.074 1.075v4.375h4.375V3.642H3.902zm4.375 5.625H3.902v4.375h4.375V9.267zm-4.375 10h4.375v-4.375H3.902v4.375zm10-11.25V3.642H9.527v4.375h4.375zm-4.375 1.25v4.375h4.375V9.267H9.527zm0 5.625v4.375h4.375v-4.375H9.527zm10-11.25h-4.375v4.375h4.375V3.642zm0 5.625h-4.375v4.375h4.375V9.267zm0 10v-4.375h-4.375v4.375h4.375z" />
                    </svg>
                  </i>
                </div>
                <div
                  className={`mx-8 mx-lg-1 cursor-pointer d-none d-md-block${
                    layoutStorage.catalogLayout.columns === 4 ? " active" : ""
                  }`}
                  data-value="4"
                  // data-active-lg="true"
                  onClick={() =>
                    layoutStorage.changeColumns("catalogLayout", 4)
                  }
                >
                  <i>
                    <svg
                      aria-hidden="true"
                      focusable="false"
                      role="presentation"
                      className="icon icon-theme-305"
                      viewBox="0 0 24 24"
                    >
                      <path d="M21.245 2.577a.605.605 0 0 0-.439-.186h-17.5a.602.602 0 0 0-.439.186.598.598 0 0 0-.186.44v17.629h.025c.024.114.07.22.16.31a.6.6 0 0 0 .439.186h17.5a.6.6 0 0 0 .439-.186.595.595 0 0 0 .16-.31h.025V3.017a.592.592 0 0 0-.184-.44zm-1.064 12.94h-3.125v-3.125h3.125v3.125zm0 1.25v3.125h-3.125v-3.125h3.125zm-11.875-1.25v-3.125h3.125v3.125H8.306zm3.125 1.25v3.125H8.306v-3.125h3.125zm-7.5-8.75h3.125v3.125H3.931V8.017zm0-1.25V3.642h3.125v3.125H3.931zm11.875 1.25v3.125h-3.125V8.017h3.125zm-3.125-1.25V3.642h3.125v3.125h-3.125zm-1.25 4.375H8.306V8.017h3.125v3.125zm-7.5 1.25h3.125v3.125H3.931v-3.125zm8.75 0h3.125v3.125h-3.125v-3.125zm7.5-1.25h-3.125V8.017h3.125v3.125zm0-4.375h-3.125V3.642h3.125v3.125zm-8.75 0H8.306V3.642h3.125v3.125zm-7.5 10h3.125v3.125H3.931v-3.125zm8.75 0h3.125v3.125h-3.125v-3.125z" />
                    </svg>
                  </i>
                </div>
                {/* <div className="mx-8 mx-lg-1 cursor-pointer d-none d-lg-block" */}
                {/*     data-value="list"> */}
                {/*  <i> */}
                {/*    <svg aria-hidden="true" focusable="false" */}
                {/*         role="presentation" className="icon icon-theme-187" */}
                {/*         viewBox="0 0 24 24"> */}
                {/*      <path */}
                {/*        d="M20.574 2.567a.61.61 0 0 0-.449-.176H3.25c-.183 0-.332.059-.449.176s-.176.268-.176.45v16.875c0 .183.059.332.176.449s.267.176.449.176h16.875c.182 0 .332-.059.449-.176s.176-.267.176-.449V3.017a.613.613 0 0 0-.176-.45zM8.25 19.267H3.875v-4.375H8.25v4.375zm0-5.625H3.875V9.267H8.25v4.375zm0-5.625H3.875V3.642H8.25v4.375zm11.25 11.25h-10v-4.375h10v4.375zm0-5.625h-10V9.267h10v4.375zm0-5.625h-10V3.642h10v4.375z"/> */}
                {/*    </svg> */}
                {/*  </i> */}
                {/* </div> */}
              </div>
            </PopperItem>
          </div>
        </div>
      </div>
    </div>
  );
}

CollectionControl.propTypes = {};

export default withTranslation()(observer(CollectionControl));
